module.exports = __webpack_public_path__ + "img/Button.a8579dff.png";